var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResGridStatus5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Blue{fill:#1177D7;}\r\n\t.Yellow{fill:#FFB115;}\r\n\t.Black{fill:#727272;}\r\n\t.Green{fill:#039C23;}\r\n\t.Red{fill:#D11C1C;}\r\n\t.st0{opacity:0.75;}\r\n\t.st1{opacity:0.5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Database"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Yellow",
    d: "M16,24c-5.5,0-10-1.8-10-4v4c0,2.2,4.5,4,10,4s10-1.8,10-4v-4C26,22.2,21.5,24,16,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Yellow",
    d: "M16,18c-5.5,0-10-1.8-10-4v4c0,2.2,4.5,4,10,4s10-1.8,10-4v-4C26,16.2,21.5,18,16,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Yellow",
    d: "M16,4C10.5,4,6,5.8,6,8v4c0,2.2,4.5,4,10,4s10-1.8,10-4V8C26,5.8,21.5,4,16,4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResGridStatus5);
export default __webpack_public_path__ + "static/media/resGridStatus5.325179bdcaf914638be6dc7ade99c1f1.svg";
export { ForwardRef as ReactComponent };